import React, { useState, useRef, useEffect } from "react";
import { Box, Avatar, Typography } from "@mui/material";
import FollowButton from "./FollowButton";

export default function LikesPopup({
  users = [],
  onFollowToggle,
  children,
}) {
  const anchorRef = useRef(null);
  const popupRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [localUsers, setLocalUsers] = useState(users);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  // Keep users in sync
  // useEffect(() => {
  //   setLocalUsers(users);
  // }, [users]);

  // CLOSE TIMER (buffer)
  const closeTimer = useRef(null);

  const handleMouseEnterArea = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setOpen(true);
  };

  const handleMouseLeaveArea = () => {
    // Add delay to prevent flicker + allow clicking popup
    closeTimer.current = setTimeout(() => {
      setOpen(false);
    }, 250); // ← delay is critical!
  };

  const handleToggleFollow = (user) =>
    setLocalUsers((prev) =>
      prev.map((u) =>
        u.id === user.id ? { ...u, isFollowing: !u.isFollowing } : u
      )
    );

  useEffect(() => {
    if (anchorRef.current && open) {
      const rect = anchorRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 6, left: rect.left });
    }
  }, [open]);

  useEffect(() => {
    const handleScroll = () => {
      setOpen(false);   // close the popup
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      ref={anchorRef}
      sx={{ display: "inline-block" }}
      onMouseEnter={handleMouseEnterArea}
      onMouseLeave={handleMouseLeaveArea}
    >
      {children}

      {open && localUsers.length > 0 && (
        <Box
          ref={popupRef}
          onMouseEnter={handleMouseEnterArea}
          onMouseLeave={handleMouseLeaveArea}
          sx={{
            position: "fixed",
            top: pos.top,
            left: pos.left,
            width: 300,
            maxHeight: 240,
            overflowY: "auto",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 8px 28px rgba(0,0,0,0.15)",
            zIndex: 9999,
            p: 1.5,
            border: "1px solid #EEE",
          }}
        >
          {localUsers.map((u) => (
            <Box
              key={u.id}
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 1.5,
              }}
            >
              <Avatar src={u.avatar} sx={{ width: 32, height: 32 }} />

              <Box sx={{ ml: 1, flexGrow: 1 }}>
                <Typography
                  sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}
                >
                  {u.username}
                </Typography>
              </Box>

              <FollowButton
                isFollowing={u.isFollowing}
                onToggle={() => handleToggleFollow(u)}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
